<template>
<div class="dashboard-trackplus-cards" v-on:scroll="deactivatePopover">
    <summary-card v-if="panel.panel_widget_id === 5" :panel="panel" :registrationCount="registrationCount" :devicesCount="devicesCount" :countriesCount="countriesCount" :isCombo="isCombo"></summary-card>
    <expiration-card v-if="panel.panel_widget_id == 6" :panel="panel" :expiration_details="expiration_details" :expiryVisible="expiryVisible" :openPopover="openPopover" @viewRegistration="viewRegistration" :isCombo="isCombo"></expiration-card>
    <pending-card v-if="panel.panel_widget_id === 7" :panel="panel" :pending_summary="pending_summary" :pendingVisible="pendingVisible" :openPopover="openPopover" @viewRegistration="viewRegistration" :isCombo="isCombo"></pending-card>
    <permission-access-modal></permission-access-modal>
    <registration-details-popup
      v-if="dashboardRecordsFlag"
      :dashboardRecordsFlag="dashboardRecordsFlag"
      :permissions="permissions"
      :dataRow="activeRegistrationData"
      @hidePopup="hidePopup"
      @dashboardWidgets="dashboardWidgets"
      :reportFlag="true"
    ></registration-details-popup>
    <loader :loadingStatus="loaderStatus"></loader>
</div>
</template>

<script>
import $ from 'jquery';
import Loader from '../../../UIComponents/Loader.vue';
import SummaryCard from '../../../TrackPlusDashboard/SummaryCard.vue';
import ExpirationCard from '../../../TrackPlusDashboard/ExpirationCard.vue';
import PendingCard from '../../../TrackPlusDashboard/PendingCard.vue';
import registrationDetailsPopup from '../../../Registrations/RegistrationDetailsPopup.vue';
import PermissionAccessModal from '../../../Common/PermissionAccessModal.vue';
import validateRegDetailsData from '../../../../utils/registrationDetails';
import { getDashboardSummary } from '../../../../apis/dashboard';
import { getChartsDataOverView } from '../../../../apis/reports';
import { getRegistrationDetailsById } from '../../../../apis/registrations';

export default {
  components: {
    Loader,
    SummaryCard,
    ExpirationCard,
    PendingCard,
    PermissionAccessModal,
    registrationDetailsPopup,
  },
  props: ['name', 'panel', 'permissions', 'isCombo'],
  data() {
    return {
      dashboardRecordsFlag: false,
      loaderStatus: false,
      registrationCount: 0,
      devicesCount: 0,
      countriesCount: 0,
      expiration_details: {},
      pending_summary: {},
      editFlag: '',
      activeRegistrationData: {},
      expiryVisible: [false, false, false, false],
      pendingVisible: [false, false, false],
      openPopover: false,
      clickPopover: false,
    };
  },
  methods: {
    dashboardWidgets() {
      this.activeRegistrationData = {};
      this.dashboardRecordsFlag = false;
    },
    closeModal(e) {
      if (this.editFlag) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
      this.activeId = '';
      this.displayRegFlag = false;
      return true;
    },
    hidePopup(value) {
      this.editFlag = value;
    },
    hidePopover() {
      this.clickPopover = false;
    },
    activatePopover() {
      this.openPopover = false;
      this.clickPopover = true;
    },
    deactivatePopover() {
      if (window.scrollY && this.clickPopover) {
        this.openPopover = true;
      }
    },
    async viewRegistration(registrationId, type, index) {
      this.activeRegistration = {};
      this.dashboardRecordsFlag = true;
      if (this.permissions.indexOf('REG_TRACKER_RECORDS') === -1) {
        $('#permissionAccessModal').modal({
          backdrop: 'static',
          keyboard: false,
        });
      } else {
        if (this.userRoleId === 4) {
          return;
        }
        this.loaderStatus = true;
        if (type) {
          if (type === 'expiry') {
            this.expiryVisible[index] = false;
          } else {
            this.pendingVisible[index] = false;
          }
          const all = document.getElementsByClassName('popper-custom-class');
          for (let i = 0; i < all.length; i += 1) {
            all[i].style.display = 'none';
          }
        }
        const selectedRegistration = await getRegistrationDetailsById(
          registrationId,
        );
        this.loaderStatus = false;
        if (selectedRegistration && selectedRegistration.error) {
          this.$notify({
            clear: true,
            group: 'custom-notification',
          });
          this.$notify({
            type: 'error',
            title: 'Error',
            text: 'Registration is not found!',
            group: 'custom-notification',
          });
        } else if (selectedRegistration) {
          this.activeRegistrationData = validateRegDetailsData(selectedRegistration);
          $('#registrationDetail').modal();
        }
      }
    },
    async getChartsDataOverView() {
      const data = await getChartsDataOverView();
      this.registrationCount = data.noOfRegistrations;
      this.devicesCount = data.noOfDevices;
      this.countriesCount = data.noOfCountries;
    },
    async getDashboardSummary() {
      this.loaderStatus = true;
      const {
        expiration_details: expirationDetails,
        pending_summary: pendingSummary,
      } = await getDashboardSummary();
      this.pending_summary = pendingSummary;
      this.expiration_details = expirationDetails;
      this.loaderStatus = false;
    },
  },
  mounted() {
    $('#registrationDetail').on('hide.bs.modal', this.closeModal);
  },
  async created() {
    this.getDashboardSummary();
    this.getChartsDataOverView();
  },
};
</script>
<style scoped>
</style>
